<template>
  <div>
    <Button @click="handlerClick()">{{buttonShowText}}</Button>
    <Modal
      v-model="modalStatus"
      width="650"
      @on-ok="handlerOk"
      @on-cancel="handlerCancel"
      title="选择组织部门"
    >
      <div class="content">
        <el-tree
          highlight-current
          check-on-click-node
          :check-strictly="true"
          node-key="id"
          show-checkbox
          :render-content="renderContent"
          :expand-on-click-node="false"
          :data="allDepartments"
          :props="defaultProps"
          default-expand-all
          ref="departmentTree"
          @check-change="getSelectedDepartment"
        ></el-tree>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    selectedDepartment: {
      type: Array,
      default: function() {
        return [];
      }
    },
    showText: {
      type: String,
      default: "请选择部门"
    }
  },

  watch: {
    selectedDepartment: {
      handler(val) {
        this.setCheckedDepartment(val);
      },
      deep: true
    }
  },
  computed: {
    buttonShowText() {
      var text = this.showText;
      if (this.selectedDepartment.length) {
        var departmentNames = this.selectedDepartment.map(item => {
          var isManager = item.isDepartmentManager ? "(主管)" : "";
          return item.departmentName + isManager;
        });
        text = departmentNames.reduce((curr, next) => {
          return curr + "，" + next;
        });
      }
      return text;
    }
  },

  data() {
    return {
      modalStatus: false,
      //编辑之前的值
      departmentsBeforeEditing: [],
      selectedDepartmentIds: [],
      allDepartments: [],
      //树形控件节点对应
      defaultProps: {
        children: "children",
        label: "departmentName",
        id: "id"
      }
    };
  },

  methods: {
    //根据部门id设置是否为该部门主管
    traversalSetting(id, isDepartmentManager) {
      function traversal(treeData) {
        for (var i = 0; i < treeData.length; i++) {
          if (treeData[i].children) {
            traversal(treeData[i].children);
          }
          if (treeData[i].id === id) {
            return (treeData[i].isDepartmentManager = isDepartmentManager);
          }
        }
      }
      traversal(this.allDepartments);
    },

    initDepartment(treeData) {
      for (var i = 0; i < treeData.length; i++) {
        //默认全部初始化为false
        treeData[i].isDepartmentManager = false;
        if (treeData[i].children) {
          this.initDepartment(treeData[i].children);
        }
      }
    },

    //获取部门
    getDepartments() {
      this.$api.getOrganizationAll().then(data => {
        this.initDepartment(data);
        this.allDepartments = data;
        if (this.selectedDepartment.length) {
          this.setCheckedDepartment(this.selectedDepartment);
        }
      });
    },

    //获取选择的部门
    getSelectedDepartment() {
      //当前选择的部门id
      var currentDepartmentIds = this.$refs.departmentTree.getCheckedKeys();
      //筛选出来新增的部门id
      var departmentNewAddIds = currentDepartmentIds.filter(item => {
        return !this.selectedDepartmentIds.includes(item);
      });
      //设置新增的部门主管默认为false
      departmentNewAddIds.forEach(item => {
        this.traversalSetting(item, false);
      });

      this.selectedDepartmentIds = currentDepartmentIds.concat();
    },

    changeIsManager(data, event) {
      this.traversalSetting(data.id, event);
    },

    //是否是本部门主管节点
    renderContent(h, { node, data, store }) {
      var _this = this;
      return (
        <span class="custom-tree-node">
          <span> {node.label} </span>
          <span>
            <el-checkbox
              v-show={_this.selectedDepartmentIds.includes(data.id)}
              on-input={event => {
                _this.changeIsManager(data, event);
              }}
              value={data.isDepartmentManager}
            >
              是本部门主管
            </el-checkbox>
          </span>
        </span>
      );
    },

    //设置部门节点
    setCheckedDepartment(departments) {
      var departmentIds = departments.map(item => {
        return item.id;
      });

      this.selectedDepartmentIds = departmentIds.concat();
      //设置勾选的状态
      this.$refs.departmentTree.setCheckedKeys(departmentIds, true);

      //设置是否是主管
      departments.forEach(item => {
        this.traversalSetting(item.id, item.isDepartmentManager);
      });
    },

    handlerClick() {
      //记录初始值
      this.departmentsBeforeEditing = this.selectedDepartment.concat();
      this.getDepartments();
      this.modalStatus = true;
    },

    //取消
    handlerCancel() {
      this.setCheckedDepartment(this.departmentsBeforeEditing);
    },

    //确定
    handlerOk() {
      this.$emit("byDepartments", this.sendSelectedData());
    },

    //根据部门id查询当前部门的某个属性
    findAttrByDepartmentId(id, attr) {
      var attrVal = "";
      function traversal(treeData) {
        for (var i = 0; i < treeData.length; i++) {
          if (treeData[i].id === id) {
            return (attrVal = treeData[i][attr]);
          }
          if (treeData[i].children) {
            traversal(treeData[i].children);
          }
        }
      }
      traversal(this.allDepartments);
      return attrVal;
    },

    //父组件接受数据
    sendSelectedData() {
      //处理数据
      if (!this.selectedDepartmentIds.length) {
        return [];
      }
      return this.selectedDepartmentIds.map(item => {
        return {
          id: item,
          isDepartmentManager: this.findAttrByDepartmentId(
            item,
            "isDepartmentManager"
          ),
          departmentName: this.findAttrByDepartmentId(item, "departmentName")
        };
      });
    }
  }
};
</script>


<style scoped>
::v-deep .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  padding-right: 8px;
}

.el-tree-node {
  margin: 8px 0 0 0;
}

.search {
  height: 50px;
  width: 320px;
}
.content {
  max-height: 400px;
  overflow: auto;
}
.searchTop {
  width: 200px;
  margin-right: 20px;
}
</style>
